function setHeaderHeight() {
    const header = document.querySelector('.js-header');
    const headerHeight = getComputedStyle(header).height;
    document.documentElement.style.setProperty('--header-height', headerHeight);
}

window.addEventListener('resize', setHeaderHeight);
document.addEventListener('DOMContentLoaded', setHeaderHeight);

let lastScrollTop = 0; // Keeps track of the last scroll position
const header = document.querySelector('.js-header'); // Your header element
let isSticky = false;
let transitionEnabled = false;
const directionThreshold = 3; // Pixels to ignore minor scroll jitter
let hasShownOnce = false; // Tracks if the header has been revealed at least once

// Listen for the scroll event
window.addEventListener('scroll', function () {
    let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = header.offsetHeight; // Compute dynamically in case of resize/content changes

    // When back to the very top, reset all state
    if (currentScroll === 0) {
        header.classList.remove('-sticky', '-transition', '-active');
        document.body.classList.remove('-stickyMenu');
        isSticky = false;
        transitionEnabled = false;
        hasShownOnce = false;
        lastScrollTop = 0;
        return;
    }

    // Determine scroll direction with a small threshold to avoid jitter
    const scrollingDown = currentScroll > (lastScrollTop + directionThreshold);
    const scrollingUp = currentScroll < (lastScrollTop - directionThreshold);

    // Ensure sticky is applied past the header height without transition and hidden initially
    if (!isSticky && currentScroll > headerHeight) {
        // Hard-disable transitions for initial stick so it cannot animate
        header.style.transition = 'none';
        header.classList.add('-sticky');
        header.classList.remove('-transition');
        header.classList.remove('-active');
        isSticky = true;
    }

    // (removed) Early toggle removed to avoid first-time hide animation

    // Enable transition once beyond small buffer
    if (isSticky && !transitionEnabled && currentScroll > (headerHeight + 10)) {
        // Re-enable CSS transitions from the class, remove inline override
        header.style.transition = '';
        // Force reflow to ensure inline removal takes effect before class is added
        void header.offsetHeight;
        header.classList.add('-transition');
        transitionEnabled = true;
    }

    // Show on upward scroll; hide on downward scroll only after it has been shown once
    if (isSticky) {
        if (scrollingUp) {
            // Ensure transition is enabled before revealing, so it animates the first time
            if (!transitionEnabled) {
                header.style.transition = '';
                void header.offsetHeight;
                header.classList.add('-transition');
                transitionEnabled = true;
            }
            header.classList.add('-active');
            document.body.classList.add('-stickyMenu');
            hasShownOnce = true;
        } else if (scrollingDown) {
            // Only allow hide animation after we have revealed once and are past the buffer
            if (hasShownOnce && transitionEnabled && currentScroll > (headerHeight + 10)) {
                header.classList.remove('-active');
                document.body.classList.remove('-stickyMenu');
            }
        }
    }

    // Update lastScrollTop to the current scroll position
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Ensure it doesn't go negative
}, false);